<h1 mat-dialog-title style="text-align:center; margin-bottom: 16px; margin-left: -5px;">
  {{data.title}}
</h1>

<mat-dialog-content>
  <div style="display: flex; gap: 20px;">
    <p>{{data.message}}</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button tabindex="-1" (click)="onCancel()" color="warn" mat-dialog-close mat-stroked-button>
    <mat-icon>cancel</mat-icon> 
    {{data.cancelText}}
  </button>
  <button tabindex="-1" class="card-footer-button" mat-flat-button (click)="onConfirm()" color="accent">
    <mat-icon>check_circle</mat-icon>
    {{data.confirmText}}
  </button>
</mat-dialog-actions>
